<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-cascader
      v-model="siteDevice"
      size="small"
      :options="filterSites"
      :show-all-levels="false"
      :props="props"
      placeholder="请选择站房设备"
      @change="onCheck"
    ></el-cascader>

    <!-- <site-query :sites="filterSites" :query="query" />

    <factor-tree-query ref="factor-tree" :factor-tree="factorTree" :query="query" title="设备因子" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>

    <el-button
      :disabled="dataList.length === 0"
      type="success"
      size="small"
      icon="el-icon-download"
      @click="onDownloadBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

        <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <display-type
          :default-display-type.sync="displayType"
          style="margin-left:20px;"
          @change="onDisplayTypeChanged"
        />
        <el-button size="small" @click="onOpenEditor">标记说明</el-button>
      </template>

      <!-- <data-table
        v-if="displayType === 1"
        ref="dataTable"
        :key="dataTableKey"
        :columns="tableColumns"
        :data="tableDataList"
        :pagination="pagination"
        selected-style
      /> -->

      <z-table
        v-if="displayType === 1"
        ref="dataTable"
        :key="dataTableKey"
        :columns="tableColumns"
        :data="tableDataList"
        :pagination="pagination"
        selected-row-style
        class="legend-table no-wrap-table"
      >
        <template v-for="(column, i) in tableColumns" :slot="column.prop" :lable="column.label" :width="column.width" slot-scope="{row}">
          <div :key="i" :class="` ${row[column.prop + 'Integral'] ? 'integral-data' : 'normal-data'}`">
            {{row[column.prop]}}
          </div>
        </template>
      </z-table>

      <div v-else>
        <category-factor-chart-group
          v-for="data in dataList"
          v-if="data.dimensions.length > 0"
          :key="data.id"
          :factor-group-map="factorGroupMap"
          :data-config="data"
          :unit-prop="unitProp"
        />
      </div>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
    />
  </template>
</layout-content>
</template>

<script>
import YaoBaseSiteFactorData from '../../YaoBaseSiteFactorData'
import DeviceCategoryConfig from '../../../model/DeviceCategoryConfig'
import CSVDownloader from '../../../utils/CSVDownloader'

import LayoutContent from '../../../components/Layout/Content'
import DataTimeQuery from '../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../components/Data/DataWrapper'
import UnitSwitch from '../../../components/Data/UnitSwitch'
import DisplayType from '../../../components/Data/DisplayType'
import CategoryFactorChartGroup from '../../../components/Data/ChartWrapper/CategoryFactorChartGroup'
import ZTable from '../02Normal/08VOCs-Data-Compare/ZTable'
import ZTablePagination from '../02Normal/08VOCs-Data-Compare/ZTablePagination'
import Editor from './Editor'

export default {
  name: 'DataManagementDataDownload',
  routeInfo: {
    label: '数据下载',
    icon: 'fa fa-users'
  },
  extends: YaoBaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, FactorTreeQuery, CompletedQuery, DataWrapper, UnitSwitch, DisplayType, CategoryFactorChartGroup, ZTable, Editor},
  data () {
    return {
      query: {
        isFuse: false,
        isGetInvalidData: true,
        isMultipleIntegral: true
      },
      siteDevice: [],
      props: {
        children: 'devices',
        value: 'id',
        label: 'name'
      },
      displayType: 2,
      dataTableKey: 0,
      tableColumns: Object.freeze([]),
      tableDataList: Object.freeze([]),
      pagination: new ZTablePagination(1, 24)
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SUN_RADIATION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GREENHOUSE_GAS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ULTRAVIOLET_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PHOTOLYSIS_RATE_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NEGATIVE_OXYGEN_ION_DEVICE_CATEGORY, false)
      ]
    },
    isSetAllFactorIds: () => 1,
    downloadName: () => '数据下载',
    currentDimensions () {
      return Object.values(this.dataList.reduce((map, dataConfig) => dataConfig.dimensions.reduce((map, dimension) => {
        let dimensionId = dimension.id

        if (!map[dimensionId]) {
          map[dimensionId] = dimension
        }

        return map
      }, map), {}))
    }
  },
  methods: {
    getEditor () {
      return this.$refs['editor']
    },
    onOpenEditor (model) {
      let refEditor = this.getEditor()
      refEditor && refEditor.open()
    },
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false
    //   this.afterSetSiteIds()
    // },
    onCheck () {
      let {filterSiteMap, siteDevice} = this
      let siteId = siteDevice[0]
      let siteDevices = filterSiteMap[siteId].devices
      this.query.siteIds = [siteId]
      let factors = siteDevices.find(el => el.id === siteDevice[1]).siteDeviceFactors
      this.query.factorIds = factors.map(el => el.factorId)
    },
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length === 0) {
        return
      }

      let {query: {siteIds}} = this

      if (siteIds.length === 0) {
        siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
        this.siteDevice = [filterSites[0].id, filterSites[0].devices[0].id]
      }

      this.afterSetSiteIds()
    },
    afterSetSiteIds () {
      if (this.setOther()) {
        this.onCheck()
        this.setCurrentQuery()
        this.getData()
      }
    },
    getSeriesParam (dimension, dimensionIds) {
      let factorId = dimensionIds[dimension ^ 1]
      return {
        type: factorId === '1011' ? 'bar' : 'line',
        showSymbol: false
      }
    },
    onDownloadBtnClick () {
      let {currentQuery: {beginTime, endTime, isAuditCompleted, isMultipleIntegral}, tableColumns, dataList, currentDimensions} = this
      let filename = `${new Date(beginTime).format('YYYY-MM-DD')}_${new Date(endTime).format('YYYY-MM-DD')}`
      let tableColumnsLen = tableColumns.length
      let csvDataList = []

      let headerColumns = ['', '']
      for (let i = 2; i < tableColumnsLen; i++) {
        headerColumns.push(tableColumns[i].label, '')
      }
      csvDataList.push(headerColumns)

      headerColumns = [tableColumns[0].label, tableColumns[1].label]
      for (let i = 2; i < tableColumnsLen; i++) {
        headerColumns.push('监测值', `数采${isAuditCompleted ? ',审核' : ''}${isMultipleIntegral ? ',重积分' : ''}标记`)
      }

      csvDataList.push(headerColumns)

      dataList.reduce((csvDataList, dataConfig) => {
        let {name, seriesMap} = dataConfig
        return dataConfig.dataTimes.reduce((csvDataList, dataTimeObj) => {
          let dataTime = dataTimeObj[1]
          csvDataList.push(currentDimensions.reduce((csvDataRow, dimension) => {
            let dimensionId = dimension.id
            let seriesItem = seriesMap[dimensionId]

            if (seriesItem) {
              // let data = seriesItem[dataTime]
              // if (data && data.value && Number.isFinite(data.value)) {
              //   if (!isMultipleIntegral) {
              //     csvDataRow.push(data.value, `${data.dasFlag ? data.dasFlag : ' '}${isAuditCompleted ? `,${data.auditFlag !== 'DELETE' ? 'R' : 'O'}` : ''}`)
              //   } else {
              //     csvDataRow.push(data.value, `${data.dasFlag ? data.dasFlag : ' '}${isAuditCompleted ? `,${data.auditFlag !== 'DELETE' ? 'R' : 'O'}` : ''}${data.isHaveIntegral ? ',重积分' : ',原始'}`)
              //   }
              // } else {
              //   csvDataRow.push('--', '--')
              // }

              let data = seriesItem[dataTime] || {}
              const {value} = data
              const flags = []

              if (data.isHaveIntegral) {
                flags.push('重积分')
              }

              const displayFlags = data.displayFlags || []

              if (displayFlags[0]) {
                flags.push(displayFlags[0])

                if (displayFlags[1]) {
                  flags[flags.length - 1] += `: ${displayFlags[1]}`
                }
              }

              csvDataRow.push(Number.isFinite(value) ? value : '--', flags.join(','))
            } else {
              csvDataRow.push('--', '--')
            }

            return csvDataRow
          }, [dataTime, name]))
          return csvDataList
        }, csvDataList)
      }, csvDataList)

      CSVDownloader(csvDataList, filename)
    },
    onDisplayTypeChanged (displayType) {
      if (displayType === 1) {
        setTimeout(() => {
          this.$refs.dataTable.doLayout()
        }, 0)
      }
    }
  },
  watch: {
    dataList (dataList) {
      let {unitProp} = this

      this.tableColumns = Object.freeze(this.currentDimensions.reduce((tableColumns, factor) => {
        let unit = factor[unitProp]
        tableColumns.push({
          prop: factor.id,
          label: `${factor.name}${unit ? `(${unit})` : ''}`,
          width: 140,
          align: 'left'
        })
        return tableColumns
      }, [{
        prop: 'dataTime',
        label: '时间',
        width: 160,
        align: 'left',
        fixed: true
      }, {
        prop: 'siteName',
        label: '站房',
        width: 160,
        align: 'left',
        fixed: true
      }]))

      this.tableDataList = Object.freeze(dataList.reduce((list, dataConfig) => {
        let {name, dimensions, seriesMap} = dataConfig
        return dataConfig.dataTimes.reduce((list, dataTimeObj) => {
          let dataTime = dataTimeObj[1]
          list.push(dimensions.reduce((formatData, dimension) => {
            let dimensionId = dimension.id
            let seriesItem = seriesMap[dimensionId]
            let data = seriesItem[dataTime]

            if (data) {
              const {value, displayFlags} = data
              formatData[dimensionId] = Number.isFinite(value) ? `${value}${displayFlags[0] ? `(${displayFlags[0]}${displayFlags[1] ? `: ${displayFlags[1]}` : ''})` : ''}` : (displayFlags[0] ? `${displayFlags[0]}${displayFlags[1] ? `: ${displayFlags[1]}` : ''}` : '--')
              formatData[dimensionId + 'Integral'] = data.isHaveIntegral
            } else {
              formatData[dimensionId] = '--'
            }

            // if (data && data.isHaveIntegral) {
            //   formatData[dimensionId] = data.value ? data.value : '--'
            // } else {
            //   if (isAuditCompleted) {
            //     if (data.auditFlag !== 'DELETE') {
            //       formatData[dimensionId] = data.value ? data.value : '--'
            //     } else {
            //       formatData[dimensionId] = '--'
            //     }
            //   } else {
            //     // 3.7前 只有这一行代码
            //     formatData[dimensionId] = data ? `${data.value ? data.value : '--'}(${data.dasFlag}${isAuditCompleted ? `, ${data.auditFlag !== 'DELETE' ? 'R' : 'O'}` : ''})` : '--'
            //   }
            // }
            formatData[dimensionId + 'Integral'] = data ? data.isHaveIntegral : false

            return formatData
          }, {
            siteName: name,
            dataTime
          }))
          return list
        }, list)
      }, []))

      if (this.displayType !== 1) {
        return
      }

      this.pagination.no = 1

      setTimeout(() => {
        this.$refs.dataTable.doLayout()
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper {
  /deep/ {
    .layout-content-body {
      .layout-content-body-inner {
        overflow: hidden !important;
      }
    }
  }
}
.no-wrap-table {
  --z-table-white-space: nowrap;
}
legend {
  font-size: 16px;
  padding: 0 1em;
  color: #303133;
  text-align: center;
}
.z-table {
  min-height: 0;
}
.integral-data {
  color: #409EFF;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/00Data-Download/index.vue